import React from 'react';
import './ticket.css';
import formattedAmount from '../seller/components/utils';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui';
import EventCard from './components/eventCard';
import RateGroupCard from '../../jo-components/cards/rateGroupCard/rateGroupCard';
import { UUID } from '../../../../src/utils/utils';
import RateCard from '../../jo-components/cards/rateCard/rateCard';
import Message from '../seller/components/message';

function Total({ totalTickets, amount }) {
    const { t } = useTranslation();

    return (
        <div className='wz-total-container'>
            <div className='wz-total-title'>{t('widget.resale.tickets.ticket', { count: totalTickets })}</div>
            <div className='wz-total-amount'>{t('widget.resale.event.from')} {amount}</div>
        </div>
    )
}

export default function TicketMarketResale({ onSubmit = () => {}, config }) {
    const { t } = useTranslation();

    const event = config['ticket-market-rates'].event;
    const max_ticket = config['ticket-market-rates'].max_ticket_per_order;
    const errors = config['ticket-market-rates'].errors
    const rates_with_group = config['ticket-market-rates'].rates_with_group
    const rates = config['ticket-market-rates'].rates
    const waiting_list_cta = config['ticket-market-rates'].waiting_list_cta;
    const soldout_label = config['ticket-market-rates'].soldout_label;
    const [selectedRates, setSelectedRates] = React.useState({});

    const total = React.useMemo(() => {
        let quantity = 0;
        let price = 0;
        for (const rate in selectedRates) {
            quantity += selectedRates[rate]['quantity'];
            price += selectedRates[rate]['price'];
        }
        return { "quantity": quantity, "price": price };
    }, [selectedRates]);

    const isDisabledSubmit = React.useMemo(() => {
        return total.quantity === 0 || total.quantity > max_ticket;
    }, [total, max_ticket]);

    const _onSubmit = React.useCallback(() => {
        if (isDisabledSubmit) {
            return;
        }
        let selected_rates = [];
        for (const [key, value] of Object.entries(selectedRates)) {
            for (let i = 0; i < value.quantity; i++) {
                selected_rates.push({
                    "auto_generated_ticket_id": UUID(key),
                    "rate": Number(key),
                    "booking":{
                        "booking_uuid": null,
                    },
                });
            }
        }       
        onSubmit({
            data: {
                cart: {
                    'attendees': selected_rates,
                    'buyer': {},
                }
            }
        });
        setSelectedRates({});
    },[selectedRates, onSubmit, isDisabledSubmit]);

    return (
        <div className='wz-event-content'>
            <div>
                <EventCard event={event} unavailable={!rates.length && !rates.length} />
                <div className='wz-rates-container'>
                    {errors.length > 0 && errors.map(error => <div className='wz-errors'><Message type='danger' description={error} /></div>)}
                    <div className='wz-tickets-title'>{t('widget.resale.tickets.title')}</div>
                    <div>
                        {rates?.map((rate, i) => {
                            return <RateCard key={i} rate={rate} selectedRates={selectedRates} setSelectedRates={setSelectedRates} event={event} disable_plus={total.quantity >= max_ticket} onSubmit={onSubmit} waiting_list_cta={waiting_list_cta} soldout_label={soldout_label} currency={event.currency} mode='resale'/>
                        })}
                        {rates_with_group?.map((group, i) => {
                            return <RateGroupCard key={i} className='wz-parent-group' group={group} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={total.quantity >= max_ticket} onSubmit={onSubmit} waiting_list_cta={waiting_list_cta} soldout_label={soldout_label} currency={event.currency} mode='resale'/>
                        })}
                        <Total totalTickets={total.quantity} amount={formattedAmount(total.price, event.currency)} />
                    </div>
                    <div className='wz-cta-container'>
                        <Button className='wz-cta-next' onClick={_onSubmit} label={t('widget.resale.tickets.cta-next')} disabled={total.quantity === 0 || total.quantity > max_ticket} />
                    </div>
                </div>
            </div>
        </div>
    )
}